import { IFontStyles } from '@fluentui/react';
import { IPMessageBar, IPText } from 'baseComponents';
import { IPMessageBarType } from 'baseComponents/MessageBar/IPMessageBar';
import { ReactNode } from 'react';

interface IInfoMessageProps {
  message?: string;
  onDismiss?: () => void;
  children?: ReactNode;
  textSize?: keyof IFontStyles;
}

const InfoMessage = (props: IInfoMessageProps) => {
  if (props.message === undefined && props.children === undefined) {
    return null;
  }

  return (
    <IPMessageBar
      messageBarType={IPMessageBarType.info}
      onDismiss={props.onDismiss}
      isMultiline={true}
      truncated={false}
    >
      {props.message && (
        <IPText variant={props.textSize ?? 'small'} block>
          {props.message}
        </IPText>
      )}
      {props.children}
    </IPMessageBar>
  );
};

export default InfoMessage;
